import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-and-definitions',
  templateUrl: './terms-and-definitions.component.html',
  styleUrls: ['./terms-and-definitions.component.scss']
})
export class TermsAndDefinitionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
